import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop,q=95/A3Qr2BKPp9ixwqK2/captura-de-pantalla-2024-02-22-a-la-s-11.25.21-a.a-m.-m6LrZ28lv4IwWGMQ.png';

export const ClientFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="no-print" style={{ backgroundColor: 'rgb(40, 37, 92)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div className="flex flex-col items-center gap-5 sm:flex-row sm:justify-between sm:items-center">
          <Link to="/" className="flex-shrink-0">
            <img
              src={LOGO_URL}
              alt="Sam's Transfer"
              className="h-10 w-auto"
              style={{ background: 'transparent', objectFit: 'contain' }}
            />
          </Link>

          <div className="text-center sm:text-right space-y-1">
            <p className="text-sm text-white/70">
              &copy; {currentYear} Sam's Transfer. Todos los derechos reservados.
            </p>
            <a
              href="https://www.samstransfer.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white hover:text-white/80 transition-colors underline underline-offset-2"
            >
              www.samstransfer.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
